<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.imageryResults', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">                   
                    <b-container>
                        <div class="list-group list-group-flush">
                            <div class="list-group-item">
                                Fichier joint:

                                <div class="font-weight-bold">
                                    <a :href="image" target="_blank" class="btn btn-success text-white"> <span class="fa fa-file"></span> {{ $t('message.preview') }} </a>
                                </div>
                            </div>
                            <div class="list-group-item">
                                {{ $t('message.typeResultat') }}:

                                <div class="font-weight-bold">
                                    {{ mResult.consultation_medecine_generale_id }}
                                </div>
                            </div>
                            <div class="list-group-item">
                                {{ $t('message.description') }}:

                                <div class="font-weight-bold">
                                    {{ mResult.description }}
                                </div>
                            </div>

                            <div class="list-group-item">
                                {{ $tc('message.dates', 1) }}:

                                <span class="font-weight-bold">
                                {{ formattedDate(mResult.date) }}
                            </span>
                            </div>
<!--                            <b-row>-->
<!--                                <b-col col sm="12">-->
<!--                                    <div class="list-group-item">-->
<!--                                        {{ $t('message.passedAt') }}:-->

<!--                                        <span class="font-weight-bold">-->
<!--                                {{ formattedDate(mResult.passed_at) }}-->
<!--                            </span>-->
<!--                                    </div>-->
<!--                                </b-col>-->
<!--                                <b-col col sm="12">-->
<!--                                    <div class="list-group-item">-->
<!--                                        {{ $t('message.archievedAt') }}:-->

<!--                                        <span class="font-weight-bold">-->
<!--                                {{ formattedDate(mResult.archived_at) }}-->
<!--                            </span>-->
<!--                                    </div>-->
<!--                                </b-col>-->
<!--                            </b-row>-->
                        </div>
                    </b-container>
                    <div class="card-footer text-right">
                        <b-row class="justify-content-sm-center">
                                <span v-if="errorshasField('nonTransmis')" style="color:red">
                                    {{getErrorsField('nonTransmis')}}
                                    </span>
                        </b-row>
                        <b-row class="justify-content-sm-center">
                            <b-button variant="primary" @click="updateResult" v-if="hasAdminRole || mResult.isAuthor || hasAssistante">
                                {{ $t('message.edit') }}
                            </b-button>
                            <b-button variant="success" @click="archieveImageryResult" v-if="!isTransmitted(mResult.passed_at) && isArchived(mResult.archived_at) && (hasMedecinControleRole || hasAdminRole || hasAssistante)" >
                                {{ $t('message.archieve') }}
                            </b-button>

                            <b-button variant="info" @click="transmitImageryResult" v-if="isTransmitted(mResult.passed_at) && ( hasPraticienRole || hasAdminRole || hasAssistante)">
                                {{ $t('message.transmit') }}
                            </b-button>
                            
                            <b-button v-b-modal.delete-modal variant="danger" v-if="hasAdminRole || mResult.isAuthor || hasAssistante">
                                {{ $t('message.delete') }}
                            </b-button>
                        </b-row>
                    </div>

                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.results', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mResult.description }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteResult">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import AppConfig from '../../../constants/AppConfig';
    import moment from 'moment';
    import _ from "lodash";

    export default {
        name: "Resultat",

        computed: {
            ...mapGetters(["result",'errors',
                'hasAdminRole',
                'hasMedecinControleRole','hasAssistante',
                'hasPraticienRole'
            ]),

            mResult: function() {
                return this.result;
            },

            isDefine:function(){
                return !_.isNull(this.mResult.file);
            },

            isImage:function(){
                if(!_.isNull(this.mResult.file) && !_.isEmpty(this.mResult.file)){
                    return (this.mResult.file).includes('.jpeg') || (this.mResult.file).includes('.png')|| (this.mResult.file).includes('.jpg');
                }
                return  false;
            },

            image: function() {
                return this.mResult.file;
            }
        },

        data() {
            return {
                result_id: this.$route.params.result
            }
        },

        methods: {
            getResult() {
                let args = {
                    result: this.result_id
                };

                this.$store.dispatch("getImageryResult", { args });
            },

            formattedDate(date) {
                return moment(date).format('DD-MM-YYYY');
            },

            updateResult() {
                this.$router.push({ name: 'edit-imagery-result', params: { result: this.result_id } });
            },

            deleteResult() {
                let self = this;
                let args = {
                    result: this.result_id
                };

                let successMessage = this.$i18n.t('message.resultDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteImageryResult', { args, index: self.result_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            },

            archieveImageryResult(){

                let self = this;
                let args = {
                    resultat: this.result_id
                };

                let successMessage = this.$i18n.t('message.reslutArchieved');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('archieveImagerieResult', { args, index: self.result_id, successMessage, errorMessages });

            },

            transmitImageryResult(){
                this.clearErrorField('nonTransmis');
                let self = this;
                let args = {
                    resultat: this.result_id
                };

                let successMessage = this.$i18n.t('message.reslutTransmitted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('transmitImagerieResult', { args, index: self.result_id, successMessage, errorMessages });

            },

            isArchived:function(date){
                let momentDate = moment(date);
                return !momentDate.isValid() ;
            },

            isTransmitted:function(date){
                var momentDate = moment(date);
                return !momentDate.isValid() ;
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            }
        },

        mounted() {
            this.getResult();
        }
    }
</script>

<style scoped>

</style>